import React from 'react';
import { Box, CircularProgress, Alert, Typography } from '@mui/material';

/**
 * Component for displaying loading and error states
 * @param {boolean} isLoading - Loading state
 * @param {boolean} loaded - Whether table size data has been loaded
 * @param {Error|null} error - Error object if any
 * @param {Function} onRetry - Retry function for error recovery
 * @returns {JSX.Element|null} - Loading or error UI, or null if no state to display
 */
const LoadingErrorState = ({ isLoading, loaded, error, onRetry }) => {
  if (isLoading || !loaded) {
    return (
      <Box 
        display="flex" 
        flexDirection="column" 
        alignItems="center" 
        justifyContent="center" 
        minHeight="400px"
        gap={2}
      >
        <CircularProgress size={48} />
        <Typography variant="body1" color="text.secondary">
          Carregando dados...
        </Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box 
        display="flex" 
        flexDirection="column" 
        alignItems="center" 
        justifyContent="center" 
        minHeight="400px"
        gap={2}
        px={2}
      >
        <Alert 
          severity="error" 
          sx={{ width: '100%', maxWidth: 600 }}
          action={
            onRetry && (
              <button
                onClick={onRetry}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#d32f2f',
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  fontSize: '0.875rem'
                }}
              >
                Tentar novamente
              </button>
            )
          }
        >
          <Typography variant="body2">
            Erro ao carregar dados: {error.message || 'Erro desconhecido'}
          </Typography>
        </Alert>
      </Box>
    );
  }

  return null;
};

export default LoadingErrorState;
